var _rect, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 63.25,
    height: 63.25,
    rx: 31.625,
    stroke: "#101828",
    strokeWidth: 0.75
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6673 44C42.6673 42.1392 42.6673 41.2089 42.4377 40.4518C41.9206 38.7473 40.5867 37.4134 38.8822 36.8963C38.1251 36.6667 37.1947 36.6667 35.334 36.6667H28.6673C26.8066 36.6667 25.8762 36.6667 25.1191 36.8963C23.4146 37.4134 22.0807 38.7473 21.5636 40.4518C21.334 41.2089 21.334 42.1392 21.334 44M38.0007 26C38.0007 29.3137 35.3144 32 32.0007 32C28.6869 32 26.0007 29.3137 26.0007 26C26.0007 22.6863 28.6869 20 32.0007 20C35.3144 20 38.0007 22.6863 38.0007 26Z",
    stroke: "#475467",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.7d881b69033b32a59fc42b46683f0878.svg";
export { ForwardRef as ReactComponent };